import { Table } from '@mantine/core';
import groupBy from 'lodash/groupBy';
import { useMemo, Fragment } from 'react';

import { INSTAGRAM_TABLE_HEADERS } from '../../../constants';
import { analyticsTypes } from '../../../types';

import { GroupHeaderRow } from './GroupHeaderRow';
import { TableRow } from './TableRow';

type InstagramAnalyticsTableProps = {
  data: analyticsTypes.InstagramReport;
};

export const InstagramAnalyticsTable = ({ data }: InstagramAnalyticsTableProps) => {
  const groupedByPagesData = useMemo(() => groupBy(data, 'pageId'), [data]);

  return (
    <Table stickyHeader striped highlightOnHover withColumnBorders withTableBorder>
      <Table.Thead>
        <Table.Tr>
          {INSTAGRAM_TABLE_HEADERS.map(({ key, label }) => (
            <Table.Th key={`header ${key}`} ta="center">
              {label}
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {Object.entries(groupedByPagesData).map(([pageId, posts]) => (
          <Fragment key={pageId}>
            <GroupHeaderRow pageId={pageId} />
            {posts.map((post) => (
              <TableRow key={post.postId} post={post} />
            ))}
          </Fragment>
        ))}
      </Table.Tbody>
    </Table>
  );
};
